import { render, staticRenderFns } from "./CandidateJobs.vue?vue&type=template&id=1483f1bd&scoped=true"
import script from "./CandidateJobs.vue?vue&type=script&lang=js"
export * from "./CandidateJobs.vue?vue&type=script&lang=js"
import style0 from "./CandidateJobs.vue?vue&type=style&index=0&id=1483f1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483f1bd",
  null
  
)

export default component.exports